export default __webpack_public_path__ + "static/media/ic_phone_black_24px.da676402.svg";